export const PUBLIC_LIVE_SESSION_PAGE_TYPES = {
  joinNowScreen: 'joinNowScreen',
  videoCallScreen: 'videoCallScreen',
}
